import React, { useState } from 'react';
import { PropertyKey, TargetNumberDto } from 'src/api/v2';
import useTargetNumbers from '../../hooks/useTargetNumbers';
import Input from 'src/components/Form/Input';
import { newValueDto } from '../../hooks/useAchievedGoalsColumns';
import { useParams } from 'react-router-dom';

export const lowercaseFirstLetter = (property: string) => {
  return property.charAt(0).toLocaleLowerCase() + property.slice(1);
};

type Props = {
  targetNumber: TargetNumberDto;
  propertyKey: PropertyKey;
  editMode: boolean;
};

const Integer = ({ targetNumber, propertyKey, editMode }: Props) => {
  const { goalId } = useParams();
  const idArray = goalId?.split('|') || [];
  const { updateMutation } = useTargetNumbers(idArray[0] || '', idArray[1] || '');
  const baseLine = targetNumber.valueDto ? targetNumber.valueDto[lowercaseFirstLetter(propertyKey)] : null;
  const [value, setValue] = useState<string>(baseLine === null ? '' : baseLine);

  const handleBlur = () => {
    const newValue = parseInt(value);
    if (newValue === baseLine || isNaN(newValue)) return;
    const newDto = { ...newValueDto };
    newDto[propertyKey] = newValue;
    updateMutation.mutateAsync([
      {
        ...targetNumber,
        valueDto: newDto,
      },
    ]);
  };

  return editMode ? (
    <Input
      className="margin--0"
      value={value}
      type="number"
      onChange={(e) => setValue(e.currentTarget.value)}
      onBlur={handleBlur}
    />
  ) : (
    <div className="margin-y--1">{value}</div>
  );
};

export default Integer;
